import { APP_NAME } from '../utils/environment';
import { default as module } from './AbstractModule';

const MODULE_NAME = 'CarouselClientMobile';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const CLASS = {
    CHANGE: `is-changing`
}

export const EVENT = {
    PLAY: `play.${EVENT_NAMESPACE}`
};


export default class extends module {
    constructor(m) {
        super(m);

        this.container = this.$('container')
        this.prev = this.$('prev')
        this.next = this.$('next')
    }

    init() {
        this.$el = $(this.el)

        this.carousel = new Swiper(this.container, {
            speed: 0,
            loop: true,
            slidesPerGroup: 2,
            slidesPerView: 2,
            grabCursor: false,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            disableOnInteraction: true,
            navigation: {
                nextEl: this.next,
                prevEl: this.prev
            },
            autoplay: {
                delay: 5000
            }
        })

        this.carousel.autoplay.stop();

        this.slideChangeBind = (param) => {
            this.slideChange()
        }

        this.carousel.on('slideChange', this.slideChangeBind);

        this.onPlayBind = (e) => {
            if(e.way == 'enter'){
                this.carousel.autoplay.start();
            }
            else {
                this.carousel.autoplay.stop();
            }
        }
        this.$el.on(EVENT.PLAY, this.onPlayBind)

    }

    slideChange() {
        this.container.classList.add(CLASS.CHANGE);

        setTimeout(() => {
            this.container.classList.remove(CLASS.CHANGE);
        }, 600);
    }

    destroy() {
        this.$el.off(EVENT.PLAY, this.onPlayBind)
        this.carousel.destroy()
    }
}
